import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { adminsSelector } from 'store/admins/selectors';

import { usePagination } from 'hooks/usePagination';

import AdminsTable from './AdminsTable';

const AdminsTableContainer = ({
  dataAction,
  params,
  ...restProps
}: { dataAction: any; params: Record<string, any> } & Record<string, any>) => {
  const { currentPage, totalPages, perPage } = useSelector(adminsSelector);
  const { i18n } = useTranslation();

  const [onPerPageChange, onPrevPageClick, onNextPageClick] = usePagination({
    dataAction,
    currentPage,
    totalPages,
    perPage,
    sortBy: params.sortBy,
    sortDirection: params.sortDirection,
  });

  return (
    <AdminsTable
      {...restProps}
      locale={i18n.language}
      currentPage={currentPage}
      totalPages={totalPages}
      perPage={perPage}
      params={params}
      onPerPageChange={onPerPageChange}
      onPrevPageClick={onPrevPageClick}
      onNextPageClick={onNextPageClick}
    />
  );
};

export default React.memo(AdminsTableContainer) as any;
